import PropTypes from 'prop-types';
import React, { cloneElement, useEffect, useRef, useState } from 'react';

import * as S from './CollapseMenu.styles';

export const CollapseMenu = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);

  const collapseId = `collapse-${title.replace(/\s+/g, '-').toLowerCase()}`;

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen, children]);

  return (
    <>
      <S.NavSection>
        <S.NavTitle
          role='button'
          tabIndex={0}
          onClick={() => setIsOpen(prev => !prev)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsOpen(prev => !prev);
            }
          }}
          aria-expanded={isOpen}
          aria-controls={collapseId}
          isOpen={isOpen}
        >
          {title}
          <S.StyledChevron isOpen={isOpen} />
        </S.NavTitle>
        <S.Content
          id={collapseId}
          aria-hidden={!isOpen}
          ref={contentRef}
          expandedHeight={height}
          isVisible={isOpen}
        >
          {React.Children.map(children, child =>
            React.isValidElement(child)
              ? cloneElement(child, {
                  'aria-hidden': !isOpen,
                })
              : child
          )}
        </S.Content>
      </S.NavSection>
      <S.HorizontalLine />
    </>
  );
};

CollapseMenu.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
